import React from "react";
import { Link } from "gatsby";
import { globalHistory } from "@reach/router";

import Layout from "../../components/layout";
import Image from "../../components/image";
import SEO from "../../components/seo";
import mobileLogo from "../../images/ud-logo.svg";
import desktopLogo from "../../images/ud-logo_w.svg";
import ProductCompareTable from "../../components/ProductCompareTable";
import { Wrap } from "../../components/ServiceEnquiry";
import ogImage from "../../images/cloudPricing-metaImg_SC.png";

const IndexPage = (props) => {
  const { location } = props;
  const [tabValue, setValue] = React.useState("security");
  const [hostname, setHostname] = React.useState("");

  const onClick = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
  };

  React.useEffect(() => {
    if (location.host) {
      console.log(location);
      let hn = location.host.includes("com.hk")
        ? "www.udomain.com.hk"
        : "www.udomain.hk";
      setHostname(hn);
    }
  }, [location]);

  const lng = "sc";
  return (
    <Layout>
      <SEO
        title="UD Cloud 云服务收费"
        description={
          "UD云端服务让你透过网络按业务需要取得运算资源，了解更多UD有关香港和中国的云端服务——包括云端整合托管、自助云端OpenCloud, 云端网页电邮寄存、云端服务器及其他云端方案。"
        }
        image={ogImage}
      />
      <main>
        <div className="page-cloudPricing">
          <div className="gradient"></div>
          <div id="global-navigation" className="global-navigation">
            <div className=" navigation-1stTier ">
              <a href={`https://${hostname}/sc`}>
                <picture>
                  <source
                    srcSet={`${mobileLogo} 1x`}
                    media="(max-width: 414px)"
                  />
                  <img
                    className="logo_ud"
                    srcSet={`${desktopLogo} 2x`}
                    alt="UD"
                  />
                </picture>
              </a>
              <ul className="list_customer ">
                <li>
                  <a
                    href={`https://${hostname}/sc/about/udomain-hong-kong-cloud-security-expert`}
                    className="list_customer-bold "
                  >
                    关于我们
                  </a>
                </li>
                <li>
                  <a
                    href={`https://${hostname}/sc/support`}
                    className="list_customer-bold "
                  >
                    技术支持
                  </a>
                </li>
                <li>
                  <a href="https://8338.hk/#!/login " className="btn_login ">
                    登入
                  </a>
                </li>
                <li>
                  <Link to="/en">EN</Link>
                </li>{" "}
                |
                <li>
                  <Link to="/tc">繁</Link>
                </li>
              </ul>
            </div>
            <ul className="list_service ">
              <li>
                <a
                  href="https://www.udomain.com/zh/main/index.php"
                  target="_blank "
                >
                  域名
                </a>
              </li>
              <li>
                <a href={`https://${hostname}/sc`} className="current ">
                  服务
                </a>
              </li>
              <li>
                <a href={`https://${hostname}/sc/solution/china-cloud`}>方案</a>
              </li>
            </ul>
          </div>
          <div className="content-container">
            <div className="header">
              <a href={`https://${hostname}`}>
                <img
                  className="header-udLogo"
                  srcSet={`${desktopLogo} 2x`}
                  alt="UD"
                />
              </a>
              <h1>UD 云服务收费</h1>
              <div className="scroll">
                <div className="cloudType-container">
                  <div id="cloudType-cloudSolution" className="cloudType-card">
                    <a
                      href={`https://${hostname}/sc/solution/managed-multi-cloud-solution-one-platform`}
                    >
                      <div className="cloudType-image-container cloudType-cloudSolution"></div>
                    </a>
                    <h2>云方案</h2>
                    <p>由UD云技术专家根据你的需要，度身订造适合你的云方案</p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/sc/solution/managed-multi-cloud-solution-one-platform`}
                      >
                        <div className="serviceListing-icon serviceListing-multiCloud"></div>
                        云端整合托管方案
                      </a>
                      <a href={`https://${hostname}/sc/solution/china-cloud`}>
                        <div className="serviceListing-icon serviceListing-chinaCloud"></div>
                        中国云端服务
                      </a>
                    </div>
                  </div>
                  <div className="cloudType-card">
                    <a
                      href={`https://${hostname}/sc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                    >
                      <div className="cloudType-image-container cloudType-openCloud"></div>
                    </a>
                    <h2>自主搭建OpenCloud</h2>
                    <p>
                      快速搭建OpenStack虚拟服务器，专为开发者而设。极速连接中港两地
                    </p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/sc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                      >
                        <div className="serviceListing-icon serviceListing-openCloud"></div>
                        OpenCloud - HK
                      </a>
                      <a
                        href={`https://${hostname}/sc/service/opencloud-server-openstack-instant-setup-us`}
                      >
                        <div className="serviceListing-icon serviceListing-openCloud"></div>
                        OpenCloud - US
                      </a>
                    </div>
                  </div>
                  <div className="cloudType-card">
                    <a
                      href={`https://${hostname}/sc/service/cloud-server/linux`}
                    >
                      <div className="cloudType-image-container cloudType-managedCloud"></div>
                    </a>
                    <h2>云服务器</h2>
                    <p>
                      24x7全天候服务器及寄存服务技术支援，为你打点一切，让你全力专注业务发展
                    </p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/sc/service/cloud-server/linux`}
                      >
                        <div className="serviceListing-icon serviceListing-cloudServer"></div>
                        云服务器
                      </a>
                      <a
                        href={`https://${hostname}/sc/service/server-dedicated-hongkong`}
                      >
                        <div className="serviceListing-icon serviceListing-dedicatedServer"></div>
                        专属服务器
                      </a>
                      <a
                        href={`https://${hostname}/sc/service/server-colocation-hosting`}
                      >
                        <div className="serviceListing-icon serviceListing-serverColocation"></div>
                        服务器托管
                      </a>
                      {/* <a href={`https://${hostname}/sc/service/cloud-storage-secure-encrypted-backup`}>
                        <div className="serviceListing-icon serviceListing-cloudStorage"></div>
                        云存储
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span id="allCloudService" className="anchor"></span>
            <div className="allCloudService">
              <h3>所有云端服务收费</h3>
              <div className="allCloudService-container">
                <a
                  href={`https://${hostname}/sc/solution/managed-multi-cloud-solution-one-platform`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-multiCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>云端整合托管方案</h4>
                    <p>跨国企业系统， 工程师24x7全天候支援</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/solution/china-cloud`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-chinaCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>中国云端服务</h4>
                    <p>利用UD专业网络服务开拓中国市场</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-openCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>OpenCloud</h4>
                    <p>专为开发者而设的自主搭建控制平台</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/cloud-server/linux`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudServer"></div>
                  <div className="allCloudService-desc">
                    <h4>云服务器</h4>
                    <p>適合電子商務及應用程式安全使用</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/server-dedicated-hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-dedicatedServer"></div>
                  <div className="allCloudService-desc">
                    <h4>专属服务器</h4>
                    <p>专业网络工程人员为你设计、架设和管理，令你无后顾之忧</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/server-colocation-hosting`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-serverColocation"></div>
                  <div className="allCloudService-desc">
                    <h4>服务器托管</h4>
                    <p>为你的服务器特设安全、稳定的环境和设备</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/cloud-storage-secure-encrypted-backup`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-serverColocation"></div>
                  <div className="allCloudService-desc">
                    <h4>云存储</h4>
                    <p>在中国和世界各地加密服务器安全备份资料</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/domain-name-search-registration`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-domainRegistration"></div>
                  <div className="allCloudService-desc">
                    <h4>域名注册</h4>
                    <p>UD提供涵盖不同范畴的域名种类供你选择</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/cloud-hosting/hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudHosting"></div>
                  <div className="allCloudService-desc">
                    <h4>云端寄存</h4>
                    <p>适合中小企发展香港业务</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/sc/service/cloud-email-hosting-hong-kong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudEmail"></div>
                  <div className="allCloudService-desc">
                    <h4>云邮箱寄存</h4>
                    <p>香港及中国首屈一指电邮寄存服务，设有24x7技术支援</p>
                  </div>
                </a>
              </div>
              <a
                href={`https://${hostname}/sc/about/why-udomain`}
                className="btn-white"
              >
                为何选择 UD Cloud ?
              </a>
              <a
                href={`https://${hostname}/sc/service/what-is-cloud-computing-service`}
                className="btn-blue"
              >
                甚么是云端运算？
              </a>
            </div>

            <div className="section-value">
              <div className="content-container">
                <h3>我们的信念</h3>
                <div className="graphic-value-container">
                  <div className="graphic-value">
                    <div className="image-container image-service" />
                    <p>贴心服务</p>
                  </div>
                  <div className="graphic-value">
                    <div className="image-container image-security" />
                    <p>网络安全</p>
                  </div>
                  <div className="graphic-value">
                    <div className="image-container image-speed" />
                    <p>强劲网速</p>
                  </div>
                </div>
                <div className="text-value-container">
                  <div>
                    <h4>贴心服务</h4>
                    <p>
                      UD自设24
                      小时技术支援热线，由本地IT专业团队以粤语、国语或英语与你沟通，服务灵活机动。除即时排忧解困之外，我们更会想多一步、预视未来，建构适合长期发展的一站式网络解决方案，从头指引客户成长道路。
                    </p>
                  </div>
                  <div>
                    <h4>网络安全</h4>
                    <p>
                      捍卫您的网络安全从来都是我们最重要的任务。
                      UD的网络安全管理团队已准备就绪，全力捍卫你的网上资产。我们的无间网络监察、防火墙及服务器设置、更新管理及数据备份等，均能确保你的网上业务安全无误。
                    </p>
                  </div>
                  <div>
                    <h4>强劲网速</h4>
                    <p>
                      UD自置超过100Gb+的本地帶宽直达香港国际互联网交换中心（HKIX），更备CN2高质量中港线路、CDN
                      及环球频宽，让你以高速、可靠稳定的网络连系香港、内地以至全球各地。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <ProductCompareTable
              hostname={hostname}
              lng="sc"
              t={{
                "storageCompChart.viewSolution": "了解更多",
                "storageCompChart.use.title": "易于上手",
                "storageCompChart.usage.title": "用途",
                "storageCompChart.usage.opencloud": "即时架设配置",
                "storageCompChart.usage.multicloud": "企业系统方案",
                "storageCompChart.usage.hosting": "基本网站",
                "storageCompChart.usage.colocate": "企业系统",
                "storageCompChart.usage.cloud": "电子商贸平台，高安全性系统",
                "storageCompChart.traffic.title": "应付流量",
                "storageCompChart.title": "我应该用哪种云端服务呢？",
                "storageCompChart.support.title": "售後支援",
                "storageCompChart.support.selfmanage": "自助管理平台",
                "storageCompChart.support.engineersupport": "24 x 7 技术支援",
                "storageCompChart.seePricing": "查看定价",
                "storageCompChart.seePackage": "查看定价",
                "storageCompChart.scale.title": "弹性",
                "storageCompChart.resources.title": "资源",
                "storageCompChart.resources.shared": "共享",
                "storageCompChart.resources.dedicated": "专属",
                "storageCompChart.power.title": "运算力",
                "storageCompChart.opencloud": "OpenCloud云服务器",
                "storageCompChart.multicloud": "跨云端管理服务",
                "storageCompChart.hosting": "云端寄存及电邮",
                "storageCompChart.colocate": "服务器托管",
                "storageCompChart.cloud": "云服务器",
              }}
            />

            <div className="highlights_resources">
              <div className="pricingHighlights">
                <h3>收费特色</h3>
                <div className="highlights_resources-content">
                  <div className="highlights-container">
                    <div className="highlights-icon-container highlights-icon-payasyougo"></div>
                    <div className="highlights-text-container">
                      <h4>按用量收费</h4>
                      <p>按照业务需要随时调整用量，增加灵活性</p>
                      <a
                        href={`https://${hostname}/sc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                      >
                        OpenCloud收费
                      </a>
                    </div>
                  </div>
                  <div className="highlights-container">
                    <div className="highlights-icon-container highlights-icon-payless"></div>
                    <div className="highlights-text-container">
                      <h4>服务年期愈长 开支节省愈多</h4>
                      <p>较长年期服务计划可让你节省20%或以上开支</p>
                      <span>
                        <a
                          href={`https://${hostname}/sc/service/cloud-server/linux`}
                        >
                          云服务器
                        </a>{" "}
                        |{" "}
                        <a
                          href={`https://${hostname}/sc/service/cloud-hosting/hongkong`}
                        >
                          云端寄存
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="resourcePackages">
                <h3>资源组合</h3>
                <div className="highlights_resources-content">
                  <p>
                    特设多个资源组合，为你提供更大灵活性且更符合成本效益。凡惠顾资源组合，将可在未来订单享受折扣。
                  </p>
                  <div className="resourcePackages-listing-container">
                    <a
                      href={`https://${hostname}/sc/service/network/global-cdn-content-delivery-network-international`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-globalCDN"></div>
                      环球CDN
                    </a>
                    <a
                      href={`https://${hostname}/sc/service/network/china-cdn-content-delivery-network-icp`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-chinaCDN"></div>
                      中国线路CDN
                    </a>
                    <a
                      href={`https://${hostname}/sc/service/network-cybersecurity-cloud-server-firewall`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-cloudSecurity"></div>
                      云端安全
                    </a>
                    <a
                      href={`https://${hostname}/sc/service/vas/media-streaming-service`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-liveStreaming"></div>
                      现场串流直播服务
                    </a>
                    <a href={`https://${hostname}/sc/service/vas/web-design`}>
                      <div className="resourcePackages-icon-container resourcePackages-icon-webDesign"></div>
                      网页设计
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-number">
              <div className="content-container">
                <h3>我们的数字</h3>
                <div className="number-items">
                  <div>
                    <p className="number-stat">100Gb+</p>
                    <p>本地带宽专线直驳HKIX</p>
                  </div>
                  <div>
                    <p className="number-stat">20+</p>
                    <p>网络经验</p>
                  </div>
                  <div>
                    <p className="number-stat">300Gb+</p>
                    <p>中国及全球带宽覆盖</p>
                  </div>
                  <div>
                    <p className="number-stat">99.99%</p>
                    <p>在线时间保证</p>
                  </div>
                  <div>
                    <p className="number-stat">24x7</p>
                    <p>本地电话及线上技术支援</p>
                  </div>
                  <div>
                    <p className="number-stat">25k+</p>
                    <p>客户遍布全球</p>
                  </div>
                </div>
              </div>
            </div>
            <a
              href={`https://${hostname}/sc/about/data-center-hong-kong-infrastructure-server-node`}
              className="btn-blue"
            >
              我们的数据中心
            </a>
            <a
              href={`https://${hostname}/sc/about/why-udomain`}
              className="btn-white"
            >
              为何选用UD?
            </a>
            <a href={`https://${hostname}/sc/customer`} className="btn-white">
              我们的顾客
            </a>

            <a
              href={`${hostname}/${lng}/case-study/article/cloud-server-case-study-ztore-hong-kong-online-shop`}
            >
              <div className="testimonial">
                <p>
                  "一开始我们就选用
                  <b>UD作为网购平台的云端寄存公司</b>
                  ，负责开发及支援网络架构、应付网络安全和在线人流，让我们腾出时间和人手专注发展业务。"
                </p>
                <p>Andrew，网上士多创办人之一</p>
                <div className="image-container image-ztore" />
              </div>
            </a>
            <div className="caseStudy">
              <h3>客戶成功案例</h3>
              <input
                type="radio"
                name="tabset"
                id="security"
                value="security"
                onClick={onClick}
                checked={tabValue === "security"}
              />
              <input
                type="radio"
                name="tabset"
                id="cloud"
                value="cloud"
                onClick={onClick}
                checked={tabValue === "cloud"}
              />
              <input
                type="radio"
                name="tabset"
                id="solution"
                value="solution"
                onClick={onClick}
                checked={tabValue === "solution"}
              />
              <ul className="tabs">
                <label htmlFor="security">
                  <li>UD 网络安全</li>
                </label>
                <label htmlFor="cloud">
                  <li>UD 云端</li>
                </label>
                <label htmlFor="solution">
                  <li>UD 中国方案</li>
                </label>
              </ul>
              <div className="tab-content">
                <div className="tab-item tab-security">
                  <div className="casestudy-description active-security">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/penetration-test-case-study-enterprise-annual-audit-check`}
                    >
                      <h4>跨国集团周年网络安全检查</h4>
                      <p>渗透测试服务</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/ddos-pretection-case-study-us-foreign-exchange`}
                    >
                      <h4>美国外汇网站</h4>
                      <p>DDoS 防御</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/penetration-test-case-study-hong-kong-school-system`}
                    >
                      <h4>香港学校和线上学习系统</h4>
                      <p>渗透测试服务</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/hacking-recovery-case-study-hk-lingerie-online-shop`}
                    >
                      <h4>香港知名内衣品牌</h4>
                      <p>骇客入侵修复</p>
                    </a>
                  </div>
                </div>
                <div className="tab-item tab-cloud">
                  <div className="casestudy-description  active-cloud">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-ztore-hong-kong-online-shop`}
                    >
                      <h4>士多 Ztore - 香港大型网上商店</h4>
                      <p>云端服务器及整合服务</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-hk-soft-drink-promotion-apps`}
                    >
                      <h4>香港饮料手机程式</h4>
                      <p>云端服务器</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-timable-hk-event-listing-startup`}
                    >
                      <h4>Timable - 香港 Startup 活动资讯网站</h4>
                      <p>云端服务器</p>
                    </a>
                  </div>
                </div>
                <div className="tab-item tab-solution">
                  <div className="casestudy-description  active-solution">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/china-routing-cdn-case-study-jwewlry-shop-entering-china`}
                    >
                      <h4>国际珠宝品牌發展中国业务</h4>
                      <p>中国线路CDN</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      to={`https://${hostname}/${lng}/case-study/article/dedicated-server-case-study-talkbox-china-voice-im-apps`}
                    >
                      <h4>Talkbox - 即时通讯手机程式</h4>
                      <p>专属服务器(中国)</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="banner-UDcloud">
              <div className="banner-content-container">
                <p>让业务在云服务起飞</p>
                <div className="logo-ud"></div>
                <div className="graphic-banner-UDcloud"></div>
              </div>
            </div>

            <Wrap>
              <div className="serviceEnquiry">
                <Link
                  className="btn-onlineQuotation"
                  to="#allCloudService"
                  data-cta="Quotation-Online"
                >
                  所有云端服务
                </Link>
                <a
                  className="btn-serviceEnquiry"
                  href={`https://${hostname}/${lng}/enquiry?enquiryType=campaign&campaignName=Cloud%20Pricing`}
                  data-cta="Service-Enquiry"
                >
                  服务查询
                </a>
                <p className="phoneNumBlk">
                  欢迎致电客户服务部热线了解更多详情
                  <br />
                  <span className="phoneNum">
                    <a href="tel:+85225547545" data-cta="CS-Call-Service">
                      (852) 2554 7545
                    </a>
                  </span>
                </p>
              </div>
            </Wrap>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default IndexPage;
